module.exports = __webpack_public_path__ + "img/3.42e4df9a.jpg";